import { useState } from 'react';

export const C = {
  bg: '#0f1923', card: '#1a2535', surface: '#243447', border: '#2d4060',
  text: '#f1f5f9', muted: '#64748b', subtle: '#94a3b8',
  green: '#00ff88', info: '#00d4ff', warning: '#f59e0b',
  danger: '#ef4444', purple: '#7b2fff',
};

export const vendorColor = (status) => {
  if (!status) return C.muted;
  const s = status.toUpperCase();
  if (s === 'ACTIVE')       return C.green;
  if (s === 'FREE_FOREVER') return C.green;
  if (s === 'PLANNED')      return C.info;
  if (s === 'EVALUATING')   return C.warning;
  if (s === 'PAUSED')       return C.warning;
  if (s === 'LAST_RESORT')  return C.warning;
  if (s === 'BANNED')       return C.danger;
  if (s === 'BLOCKED')      return C.danger;
  if (s.includes('L13'))    return C.warning;
  return C.muted;
};

export const Badge = ({ color, children }) => (
  <span
    title={typeof children === 'string' ? children : undefined}
    style={{
      background: color + '22', color, border: '1px solid ' + color + '44',
      borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700,
      letterSpacing: '0.05em', whiteSpace: 'nowrap', display: 'inline-block',
      maxWidth: 420, overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'bottom',
    }}>{children}</span>
);

export const Card = ({ title, accent = C.info, children, style = {} }) => (
  <div style={{
    background: C.card, border: '1px solid ' + C.border, borderRadius: 10,
    padding: 20, borderTop: '3px solid ' + accent, ...style,
  }}>
    {title && <div style={{ color: accent, fontWeight: 700, fontSize: 12,
      letterSpacing: '0.08em', marginBottom: 12, textTransform: 'uppercase' }}>{title}</div>}
    {children}
  </div>
);

export const Row = ({ label, value, accent }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    flexWrap: 'wrap', gap: '2px 12px',
    padding: '7px 0', borderBottom: '1px solid ' + C.border + '33' }}>
    <span style={{ color: C.muted, fontSize: 13, flexShrink: 0 }}>{label}</span>
    <span style={{ color: accent || C.text, fontSize: 13, fontWeight: 600,
      textAlign: 'right', overflowWrap: 'break-word' }}>{value}</span>
  </div>
);

export const statusColor = { done: C.green, next: C.warning, planned: C.info, future: C.purple };
export const statusLabel = { done: 'DONE', next: 'NEXT', planned: 'PLANNED', future: 'FUTURE' };
export const phaseColor = {
  'Foundation': C.muted, 'Phase A': C.green, 'Phase B': C.warning,
  'Phase B+': C.warning, 'Phase C': C.info, 'Phase C/D': C.purple,
  'Phase D': C.purple, 'Phase D3a': C.purple, 'Phase D3b': C.purple,
  'Phase D3c': C.purple, 'Phase D3-Infra': C.purple, 'Monetise': '#f97316',
};

export { useState };
